/** @format */

import {ModalHeader, ModalFooter, Modal} from '@sttark/design-system';
import useDesignArchive from '../../../../shared/use_design_archive';
import {If, IfElse} from 'frontier-utilities';
import {Button} from '@sttark/design-system';
import React, {useState} from 'react';

export const ActionColumn = ({designOrder}) => {
    const [isArchived, setIsArchived] = useState(designOrder.design.is_archived);
    const [showModal, setShowModal] = useState(false);

    const handleSuccessfulUnarchive = () => {
        setShowModal(false);
        setIsArchived(false);
    };

    const {toggleIsShowingArchive, isArchivingDesign, handleUnarchive} = useDesignArchive(
        designOrder.design_id,
        undefined,
        handleSuccessfulUnarchive
    );
    return (
        <div className="action-column-02mj">
            <If condition={isArchived}>
                <IfElse condition={!isArchivingDesign}>
                    <button
                        className="p-0 m-0 color-accent-primary d-flex align-items-center justify-content-start"
                        onClick={() => setShowModal(true)}>
                        <i className="fa fa-undo me-2" />
                        <u>Un-archive design</u>
                    </button>
                    <div className="d-flex align-items-center justify-content-start gap-2">
                        <i className="fa fa-spinner fa-spin" />
                        <span>Archiving...</span>
                    </div>
                </IfElse>
            </If>
            <Modal isOpen={showModal} onClose={() => setShowModal(false)} bodyHeightAuto>
                <ModalHeader>Un-archive design</ModalHeader>
                <div>
                    <h5 style={{margin: '0 0 8px'}}>Archiving design will:</h5>
                    <p className="m-0 p-0">
                        Un-archive this design only. You can re-archive it at any time from the past
                        orders tab.
                    </p>
                </div>
                <ModalFooter>
                    <IfElse condition={!isArchivingDesign}>
                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <Button onClick={toggleIsShowingArchive} label="Cancel" secondary />
                            <Button onClick={handleUnarchive} label="Un-archive Design" />
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-2">
                            <i className="fa fa-spinner fa-spin" />
                            <span>Archiving...</span>
                        </div>
                    </IfElse>
                </ModalFooter>
            </Modal>
        </div>
    );
};
